// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import interpellationStatusEntity from './entities/interpellation-status.json';
import interpellationStatusMenu from '../pages/interpellation-status/menu.json';
import interpellationStatusFullForm from '../pages/interpellation-status/forms/full.json';
import interpellationStatusContextForm from '../pages/interpellation-status/forms/context.json';
import interpellationStatusMiniForm from '../pages/interpellation-status/forms/mini.json';
import interpellationStatusLookupForm from '../pages/interpellation-status/forms/lookup.json';
import interpellationStatusTableView from '../pages/interpellation-status/views/table.json';
import interpellationStatusDashboardView from '../pages/interpellation-status/views/dashboard.json';

/** Тип запису «Статус інтерпеляції» зі сторінками пакета: меню, форми та подання з pages/interpellation-status/. */
export const interpellationStatusDefinition: IRecordTypeDefinition = {
  ...interpellationStatusEntity,
  views: assembleViewSet({
      table: interpellationStatusTableView,
      dashboard: interpellationStatusDashboardView,
  }),
  form: interpellationStatusFullForm,
  forms: { full: interpellationStatusFullForm, context: interpellationStatusContextForm, mini: interpellationStatusMiniForm, lookup: interpellationStatusLookupForm },
  menu: interpellationStatusMenu,
} as IRecordTypeDefinition;
